import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user && user.id) navigate('/teddyfuezing/davidsidea/dashboard');
  }, [user, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/teddyfuezing/davidsidea/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(d => d.msg || JSON.stringify(d)).join(' '));
      else setError('Login failed. Check your credentials.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-neutral-950"><span className="text-neutral-500 text-xs uppercase tracking-widest">Loading...</span></div>;

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-neutral-950 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-white text-2xl font-bold tracking-tight" style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic' }}>Teddy Feuzing</h1>
          <p className="text-neutral-500 text-xs uppercase tracking-widest mt-2">Admin Access</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-neutral-400 text-xs uppercase tracking-widest">Email</Label>
            <Input id="email" data-testid="admin-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required className="mt-1.5 bg-neutral-900 border-neutral-800 text-white placeholder:text-neutral-600" placeholder="you@example.com" />
          </div>
          <div>
            <Label htmlFor="password" className="text-neutral-400 text-xs uppercase tracking-widest">Password</Label>
            <Input id="password" data-testid="admin-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required className="mt-1.5 bg-neutral-900 border-neutral-800 text-white placeholder:text-neutral-600" placeholder="Password" />
          </div>
          {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
          <Button data-testid="admin-login-button" type="submit" disabled={submitting} className="w-full bg-white text-black hover:bg-neutral-200 text-xs uppercase tracking-widest font-semibold py-5">
            {submitting ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
}
